// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import React from "react";

const IconMinus = () => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="11" height="15" viewBox="0 0 11 15">
            <path
                fill="currentColor"
                d="M5.25,0 C2.35074222,0 0,2.35074222 0,5.25 C0,7.36667979 0.737460971,7.95785153 4.71132821,13.7183597 C4.97194165,14.0948837 5.52917987,14.0948837 5.78976578,13.7183597 C9.76171875,7.95703125 10.5,7.36640608 10.5,5.25 C10.5,2.35074222 8.1484375,0 5.25,0 Z M5.25,7.41289079 C4.04332018,7.41289079 3.0625,6.43179691 3.0625,5.22539079 C3.0625,4.01898468 4.04414046,3.03789079 5.25,3.03789079 C6.45585954,3.03789079 7.4375,4.01898384 7.4375,5.22539079 C7.4375,6.43179733 6.45585954,7.41289079 5.25,7.41289079 Z"
                transform="translate(0 .75)"
            />
        </svg>
    );
};

export default React.memo(IconMinus);
